const ENTITY_TYPES = {
  agro_exporter: "agro_exporter",
  customer: "customer",
  organization: "organization",
  packing_house: "packing_house",
  producer: "producer",
  service_provider: "service_provider"
};
export default {
  methods: {
    userEntityTypesIncludes(code) {
      if (this.user_entity_types)
        return this.user_entity_types
          .map(entity_type => entity_type.type)
          .includes(code);
      return false;
    },
    userEntitiesAgroExporter() {
      if (this.user_entity_types) {
        let entities = [];
        this.user_entity_types.forEach(entity => {
          if (entity.type == ENTITY_TYPES.agro_exporter) {
            entities.push(entity);
          }
        });
        return entities;
      }
      return [];
    },
    userEntitiesCustomer() {
      if (this.user_entity_types) {
        let entities = [];
        this.user_entity_types.forEach(entity => {
          if (entity.type == ENTITY_TYPES.customer) {
            entities.push(entity);
          }
        });
        return entities;
      }
      return [];
    },
    userEntitiesPackingHouse() {
      if (this.user_entity_types) {
        let entities = [];
        this.user_entity_types.forEach(entity => {
          if (entity.type == ENTITY_TYPES.packing_house) {
            entities.push(entity);
          }
        });
        return entities;
      }
      return [];
    },
    userEntitiesOrganization() {
      if (this.user_entity_types) {
        let entities = [];
        this.user_entity_types.forEach(entity => {
          if (entity.type == ENTITY_TYPES.organization) {
            entities.push(entity);
          }
        });
        return entities;
      }
      return [];
    },
    userEntitiesProducer() {
      if (this.user_entity_types) {
        let entities = [];
        this.user_entity_types.forEach(entity => {
          if (entity.type == ENTITY_TYPES.producer) {
            entities.push(entity);
          }
        });
        return entities;
      }
      return [];
    },
    userEntitiesServiceProvider() {
      if (this.user_entity_types) {
        let entities = [];
        this.user_entity_types.forEach(entity => {
          if (entity.type == ENTITY_TYPES.service_provider) {
            entities.push(entity);
          }
        });
        return entities;
      }
      return [];
    },
    checkIfUserIsAgroExporter() {
      if (!this.user_is_agro_exporter)
        this.$router.push({ name: "logout_path" });
    },
    checkIfUserIsCustomer() {
      if (!this.user_is_customer) this.$router.push({ name: "logout_path" });
    },
    checkIfUserIsOrganization() {
      if (!this.user_is_organization)
        this.$router.push({ name: "logout_path" });
    },
    checkIfUserIsPackingHouse() {
      if (!this.user_is_packing_house)
        this.$router.push({ name: "logout_path" });
    },
    checkIfUserIsProducer() {
      if (!this.user_is_producer) this.$router.push({ name: "logout_path" });
    },
    checkIfUserIsAuthorized(role_code, permission_code, entity_type) {
      const entity = this.user_entity_types.find(
        user_entity_type => user_entity_type.type == entity_type
      );
      if (entity) {
        if (
          entity.roles
            .find(role => role.code == role_code)
            ?.permissions?.find(
              permission => permission.code == permission_code
            )
        )
          return true;
      }
      return false;
    },
    userEntityId(entity_type) {
      return this.user_entity_types.find(
        user_entity_type => user_entity_type.type == entity_type
      ).id;
    }
  },
  computed: {
    user_is_agro_exporter: function () {
      return this.userEntityTypesIncludes(ENTITY_TYPES.agro_exporter);
    },
    user_is_customer: function () {
      return this.userEntityTypesIncludes(ENTITY_TYPES.customer);
    },
    user_is_organization: function () {
      return this.userEntityTypesIncludes(ENTITY_TYPES.organization);
    },
    user_is_packing_house: function () {
      return this.userEntityTypesIncludes(ENTITY_TYPES.packing_house);
    },
    user_is_producer: function () {
      return this.userEntityTypesIncludes(ENTITY_TYPES.producer);
    },
    entity_types_codes: function () {
      return ENTITY_TYPES;
    },
    user_entity_types: function () {
      return this.$store.getters["user/getEntityTypes"];
    },
    user_entity_type_names: function () {
      return this.user_entity_types
        .map(entity => entity.name)
        .filter((value, index, self) => self.indexOf(value) === index);
    }
  }
};
